import axios from 'axios';
import { wrapApiError } from '@/utils/apiError';

const BASE_URL = process.env.VUE_APP_API_URL || 'http://127.0.0.1:8000'

export const tokenApi = {
  // WhatsApp related functions
  connectWhatsApp: async (communityId) => {
    try {
      const response = await axios.post(`${BASE_URL}/tokens/whatsapp/connect`, { community_id: communityId });
      return response.data;
    } catch (error) {
      throw wrapApiError(error, 'Failed to connect WhatsApp', 'No response from server');
    }
  },
  
  checkWhatsAppStatus: async (communityId) => {
    try {
      const response = await axios.get(`${BASE_URL}/tokens/whatsapp/status`, { params: { community_id: communityId } });
      return response.data;
    } catch (error) {
      throw wrapApiError(error, 'Failed to check the WhatsApp status', 'No response from server');
    }
  },
  
  disconnectWhatsApp: async (communityId) => {
    try {
      const response = await axios.post(`${BASE_URL}/tokens/whatsapp/disconnect`, { community_id: communityId });
      return response.data;
    } catch (error) {
      throw wrapApiError(error, 'Failed to disconnect WhatsApp', 'No response from server');
    }
  },
  
  // Telegram related functions
  validateTelegramToken: async (communityId, token) => {
    try {
      const response = await axios.post(`${BASE_URL}/tokens/telegram/validate`, { community_id: communityId, token });
      return response.data;
    } catch (error) {
      throw wrapApiError(error, 'Failed to validate the Telegram token', 'No response from server');
    }
  },

  // Get all tokens
  // getTokens: async () => {
  //   const response = await axios.get(`${BASE_URL}/tokens`);
  //   return response.data;
  // },

  // // Create new token
  // createToken: async (tokenData) => {
  //   const response = await axios.post(`${BASE_URL}/tokens`, tokenData);
  //   return response.data;
  // },

  // // Update existing token
  // updateToken: async (id, tokenData) => {
  //   const response = await axios.put(`${BASE_URL}/tokens/${id}`, tokenData);
  //   return response.data;
  // },

  // // Delete token
  // deleteToken: async (id) => {
  //   const response = await axios.delete(`${BASE_URL}/tokens/${id}`);
  //   return response.data;
  // }
};

export default tokenApi; 